export const DATA_AUTOMATION_VALUE = "check-mark-cell";
